/**
 * Search Collections Enhancement
 * Adds all collections to the predictive search dropdown
 */

(function() {
  'use strict';

  // Wait for Theme.allCollections to be available
  function enhanceSearchWithCollections() {
    if (!window.Theme || !window.Theme.allCollections) {
      console.warn('Theme.allCollections not available');
      return;
    }

    const collectionsData = window.Theme.allCollections;
    if (!collectionsData || collectionsData.length === 0) {
      return;
    }

    // Find the search results container
    const resultsContainer = document.querySelector('[data-live-search-results]');
    if (!resultsContainer) {
      return;
    }

    // Create a mutation observer to watch for search results
    const observer = new MutationObserver(function(mutations) {
      // Check if results have been updated
      const suggestionsSection = resultsContainer.querySelector('.search-flydown__queries-collections');
      
      if (suggestionsSection) {
        // Add all collections section if it doesn't exist
        addAllCollectionsSection(resultsContainer, collectionsData, suggestionsSection);
      }
    });

    // Start observing
    observer.observe(resultsContainer, {
      childList: true,
      subtree: true,
      characterData: false
    });

    // Also check on initial load
    addAllCollectionsSection(resultsContainer, collectionsData, resultsContainer.querySelector('.search-flydown__queries-collections'));
  }

  function addAllCollectionsSection(container, collectionsData, suggestionsSection) {
    // Check if we already added the collections section
    if (container.querySelector('.search-flydown__all-collections')) {
      return;
    }

    // Create the collections section
    const collectionsSection = document.createElement('div');
    collectionsSection.className = 'search-flydown__all-collections';

    // Create heading
    const heading = document.createElement('h3');
    heading.className = 'search-flydown__group-title';
    heading.textContent = (window.Theme && window.Theme.translations && window.Theme.translations.browse_collections) || 'Browse Collections';
    collectionsSection.appendChild(heading);

    // Create list
    const list = document.createElement('ul');
    list.className = 'search-flydown__group-list';

    // Add collections
    collectionsData.forEach(function(collection) {
      const item = document.createElement('li');
      item.className = 'search-flydown__list-item';
      
      const link = document.createElement('a');
      link.href = collection.url;
      link.textContent = collection.title;
      
      item.appendChild(link);
      list.appendChild(item);
    });

    collectionsSection.appendChild(list);

    // Insert after suggestions section or at the beginning
    if (suggestionsSection) {
      suggestionsSection.parentNode.insertBefore(collectionsSection, suggestionsSection.nextSibling);
    } else {
      container.insertBefore(collectionsSection, container.firstChild);
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceSearchWithCollections);
  } else {
    enhanceSearchWithCollections();
  }

  // Also run after a small delay to catch dynamic initialization
  setTimeout(enhanceSearchWithCollections, 500);
})();
